import { memo, useState } from "react";
import {
  useEnvironmentStore,
  EnvironmentName,
} from "@/store/useEnvironmentStore";
import ChangeEnvPopupDialog from "@/components/ChangeEnvPopupDialog/ChangeEnvPopupDialog";
import CONFIGS from "@/core/utils/configs";
import styles from "@/components/EnvBadge/EnvBadge.module.css";

const EnvBadge = memo(() => {
  const { env, reviewAppBranchName } = useEnvironmentStore();
  const [dialogVisible, setDialogVisible] = useState(false);

  if (
    CONFIGS.ENVIRONMENT === "prod" ||
    CONFIGS.ENVIRONMENT === "@env@" ||
    CONFIGS.ENVIRONMENT === "development"
  ) {
    return null;
  }

  const getEnvLabel = () => {
    return env === EnvironmentName.ReviewApp ? "Review App" : "Preprod";
  };

  return (
    <>
      <div
        className={styles.badgeContainer}
        onClick={() => setDialogVisible(true)}
      >
        <span className={styles.envText}>{getEnvLabel()}</span>
        {env === EnvironmentName.ReviewApp && reviewAppBranchName && (
          <span className={styles.branchText}>| {reviewAppBranchName}</span>
        )}
      </div>
      <ChangeEnvPopupDialog
        isVisible={dialogVisible}
        onClose={() => setDialogVisible(false)}
      />
    </>
  );
});

export default EnvBadge;
